var path = '/account/main/investorPortfolio/investorPortfolio.tpl.html';
var html = "<div id=grdinvestorPortfolio ifast-grid data-ng-if=investorPortfolioCtrl.isLoaded data-ifast-object-id={{investorPortfolioCtrl.objectId}} data-ifast-options=investorPortfolioCtrl.gridOptions data-ifast-use-local-data=true data-ifast-local-data=investorPortfolioCtrl.getLocalData()></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/account/main/investorPortfolio/investorPortfolio.tpl.html
// module id = 594
// module chunks = 0 2